import { render, staticRenderFns } from "./FirstCombinedStep.vue?vue&type=template&id=35def0d3&"
import script from "./FirstCombinedStep.vue?vue&type=script&lang=js&"
export * from "./FirstCombinedStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports